var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-attach",on:{"click":function($event){return _vm.selectFile()}}},[_c('img',{attrs:{"src":require("@/assets/images/icons/attach.svg"),"alt":"attach"}}),(_vm.show_input)?_c('input',{ref:"fileInput",staticClass:"file-input",attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.onFileChange}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }